'use client';

import CookieConsent from 'react-cookie-consent';

export default function CookieBanner() {
  return (
    <CookieConsent
      location="bottom"
      buttonText="Accept"
      cookieName="hooklistener-cookies"
      containerClasses="hooklistener-cookie-notice"
      contentClasses="hooklistener-cookie-content"
      buttonClasses="hooklistener-cookie-button"
      style={{
        background: 'rgba(15, 15, 25, 0.95)',
        backdropFilter: 'blur(12px)',
        boxShadow: '0 -4px 20px rgba(0, 0, 0, 0.3)',
        borderTop: '1px solid rgba(155, 116, 242, 0.3)',
        padding: '16px 24px',
        zIndex: 9999,
      }}
      buttonStyle={{
        color: '#ffffff',
        fontSize: '14px',
        background: '#9b74f2',
        borderRadius: '0.75rem',
        padding: '10px 20px',
        border: 'none',
        cursor: 'pointer',
        marginRight: '100px',
        fontWeight: '500',
        boxShadow: '0 4px 10px rgba(155, 116, 242, 0.3)',
      }}
      expires={150}
    >
      <span style={{ fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>
        This website uses cookies to enhance the user experience.{' '}
        <a
          href="/privacy"
          style={{
            textDecoration: 'underline',
            color: '#c9b6f7',
            fontWeight: '500',
          }}
        >
          Learn more
        </a>
      </span>
    </CookieConsent>
  );
}
